const SAFE_LOADER_ERROR_CODES = {
  conflict: 409,
  validationError: 422,
} as const;

const DATA_LOADER_MISMATCH_CODE = "DATA_LOADER_MISMATCH";

export { SAFE_LOADER_ERROR_CODES, DATA_LOADER_MISMATCH_CODE };
